/**
 * Choose a if condition is true or b if condition is false
 */
export const chooseAOrB =
  <A, B>(aValue: A, bValue: B) =>
  (condition: boolean) =>
    condition ? aValue : bValue;
